import { React, useEffect, useState } from 'react';
import { Card, Pane } from 'evergreen-ui';
import SignInComponent from './SignInComponent';
import SwitchSignInUpComponent from './SwitchSignInUpComponent';
import { useLocation } from 'react-router-dom';
import SignUpComponent from './SignUpComponent';
import logo from '../../assets/simboloVitaResize.png';

export default function BoxSignComponent() {
  const [login, setLogin] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);

  const switchCardSign = () => {
    let newState = !login;
    setLogin(newState);
  };

  const urlParams = useLocation().search;
  const actionParam = new URLSearchParams(urlParams).get('action');

  useEffect(() => {
    if (actionParam && actionParam == 'sign-in') {
      setLogin(true);
    } else if (actionParam && actionParam == 'sign-up') {
      setLogin(false);
    }
    
    // Add a small delay to show the animation
    setTimeout(() => {
      setIsLoaded(true);
    }, 100);
  }, [actionParam]);

  return (
    <div className='login-content'>
      <div className={`login-container ${isLoaded ? 'loaded' : ''}`}>
        <div className="login-brand">
          <img src={logo} alt="Vita Logo" className="login-logo" />
        </div>
        <Card
          className='wrap-cards-login'
          display='flex'
          flexDirection='column'
          width='100%'
          maxWidth="420px"
          border="none"
          elevation={2}
          backgroundColor='white'
          borderRadius="10px"
          overflow="hidden"
        >
          {login ? <SignInComponent /> : <SignUpComponent setLogin={setLogin} />}
          <SwitchSignInUpComponent login={login} switchCard={switchCardSign} />
        </Card>
        <div className="login-footer">
          © {new Date().getFullYear()} Vita App — Todos os direitos reservados
        </div>
      </div>
      
      <style jsx='true'>
        {`
          body, html {
            margin: 0;
            padding: 0;
            height: 100%;
            overflow: hidden;
          }

          .login-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 100vh;
            width: 100vw;
            background: linear-gradient(135deg, #f9f9fb 0%, #e4e7eb 100%);
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow-y: auto;
          }
          
          .login-content::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 5px;
            background: linear-gradient(90deg, #27E2E7, #53BCC3, #0024A4, #A96BE7);
            z-index: 10;
          }
          
          .login-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            max-width: 420px;
            margin: 0 auto;
            padding: 20px;
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease;
            box-sizing: border-box;
          }
          
          .login-container.loaded {
            opacity: 1;
            transform: translateY(0);
          }
          
          .login-brand {
            display: flex;
            justify-content: center;
            margin-bottom: 30px;
            animation: fadeIn 1s ease;
          }
          
          .login-logo {
            width: 120px;
            height: auto;
            transform: scale(1);
            transition: transform 0.3s ease;
            filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
          }
          
          .login-logo:hover {
            transform: scale(1.05);
          }
          
          .wrap-cards-login {
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
            width: 100%;
            animation: slideUp 0.6s ease forwards;
          }
          
          .login-footer {
            margin-top: 24px;
            font-size: 12px;
            color: #66788A;
            text-align: center;
            animation: fadeIn 1s ease 0.3s forwards;
            opacity: 0;
          }
          
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
          
          @media (max-width: 480px) {
            .login-container {
              padding: 16px;
            }
            
            .login-logo {
              width: 100px;
            }
            
            .login-footer {
              margin-top: 20px;
              font-size: 11px;
            }
          }
        `}
      </style>
    </div>
  );
}
